import DateService from "../../Services/Shared/Date.service";
export default class StudentFilterStatisticsDomainService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ date: Date; }' is missing the following properties from type 'StudentFilterStatistics': avgCumulativeGpaCredits, avgMajorGpa, avgCumulativeGpa, avgCumulativeCreditHoursEarned, and 16 more.
        return Object.assign(Object.assign({}, json), { 
            // use moment here because native Date was causing timezone issues.
            date: DateService.parseDateWithSameTimeInLocalTimezone(json.date) });
    }
}
